{
  "feedback-internal-details-page": {
    "buttons": {
      "submit": "EINREICHEN"
    },
    "text": {
      "comment": "Ihr Kommentar",
      "cleanliness": "Atmosphäre und Sauberkeit",
      "hint": "Bitte teilen Sie uns mit, wie Sie über unseren Service denken",
      "service": "Dienstleistungen",
      "staff": "Mitarbeiter"
    }
  }
}
